module.exports = __webpack_public_path__ + "img/wikipedia-logo.ea51e3b4.svg";